import styled from "styled-components"
import { Button } from "ui"
import { devices } from "theme/devices"

const Form = styled.form`
  position: relative;
  display: block;
  width: 100%;
  margin: 10rem 0 0;

  &::before {
    content: "";
    display: block;
    position: absolute;
    z-index: -1;
    bottom: auto;
    top: -4rem;
    left: -2rem;
    border-top-right-radius: 8rem;
    background: ${({ theme }) => theme.primary20};
    width: 100%;
    height: 60%;

    ${devices.tabletL} {
      border-radius: 0 0 0 13rem;
      height: 85%;
      left: -6rem;
      bottom: 0;
    }
  }

  ${devices.tabletL} {
    width: 40%;
    margin-top: 0;
  }
`

const Field = styled.div`
  display: block;
  margin-bottom: 2.4rem;
`

const StyledButton = styled(Button)`
  display: block;
  margin-top: 4rem;
  margin-left: auto;
  margin-right: 4rem;
`

export default { Form, Field, StyledButton }
